import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Root layout variants for the Footer composite.
 *
 * - **default** — full marketing/legal footer that composes `Footer.Top`,
 *   `Footer.Bottom`, brand, and navigation columns.
 * - **basic** — compact single-line copyright footer (Figma "Footer / Basic",
 *   used by lightweight flows such as Voyager). XL top/bottom padding,
 *   footer-sides left/right padding, content centered.
 */
export const footerVariants = cva('flex text-white bg-surface-chrome', {
  variants: {
    variant: {
      default: 'flex-col items-center gap-2xl py-16 px-8',
      basic: 'flex-col items-center py-xl px-footer-sides',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type FooterVariantProps = VariantProps<typeof footerVariants>;
